var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCardFront = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.571 5.143H3.43A.857.857 0 0 0 2.57 6v1.714h18.857V6a.857.857 0 0 0-.857-.857M2.571 18V9.429h18.857V18a.857.857 0 0 1-.857.857H3.43A.857.857 0 0 1 2.57 18M3.43 3.429A2.57 2.57 0 0 0 .857 6v12a2.57 2.57 0 0 0 2.572 2.571H20.57A2.57 2.57 0 0 0 23.143 18V6a2.57 2.57 0 0 0-2.572-2.571zM5.143 14.57a.857.857 0 0 0 0 1.715h2.571a.857.857 0 1 0 0-1.715zm-.857-1.714c0-.473.383-.857.857-.857h4.286a.857.857 0 0 1 0 1.714H5.143a.857.857 0 0 1-.857-.857m12 1.286a2.143 2.143 0 1 1-4.286 0 2.143 2.143 0 0 1 4.286 0m.214 1.856c.402-.51.643-1.155.643-1.856 0-.7-.24-1.346-.643-1.856a2.143 2.143 0 1 1 0 3.712",
  clipRule: "evenodd"
})));
export default SvgCardFront;